import { Table } from '@tanstack/react-table';
import { Input } from '../../atomic/input';
import { useTranslation } from 'react-i18next';
import { CloseIcon, SearchIcon } from '../../../icons';
import { IconButton } from '@mui/material';
import { cn } from '../../../util';
import { useState } from 'react';

interface DataTableSearchProps<TData> {
  table: Table<TData>;
  placeholder?: string;
  className?: string;
}

export function DataTableSearch<TData>({
  table,
  placeholder,
  className
}: Readonly<DataTableSearchProps<TData>>) {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const value = table.getState().globalFilter;

  return (
    <div className={cn('relative ', className)}>
      {isOpen ? (
        <Input
          autoFocus
          endAdornment={
            <IconButton
              sx={{ padding: 0 }}
              onClick={() => {
                table.setGlobalFilter('');
                setIsOpen(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          }
          className="w-[450px]"
          startAdornment={<SearchIcon />}
          placeholder={placeholder ?? t('common:SEARCH')}
          value={value ?? ''}
          onChange={(event) => table.setGlobalFilter(event.target.value)}
        />
      ) : (
        <IconButton sx={{ padding: 0 }} onClick={() => setIsOpen(true)}>
          <SearchIcon />
        </IconButton>
      )}
    </div>
  );
}
